export default __webpack_public_path__ + "static/media/nz.f113106d.svg";